import { Col, Row, Button, List, Image, Card } from 'antd';
import React, { useEffect, useState } from 'react'
import { recordError } from '../../../utils/logService';
import util from '../../../utils/functions/custom';
import EditObjectives from './EditObjectives';
import { Messages, Notify } from '../../../services/custom/Messages';
import { openNotification } from '@seims/shared';
import service from '../../../services/citizenscienceService';

export default function ProjectObjectives({ data }) {
    let msg = "";
    const [loading, setLoading] = useState(true);
    const [projectObjectives, setProjectObjectives] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        getProjects();
    }, [])


    const getProjects = async () => {
        try {
            setLoading(true);
            if (!util.isEmpty(data)) {
                setProjectObjectives(data.objectives);
            } else {
                setProjectObjectives([]);
            }

        } catch (error) {
            recordError(error);
        }
    }

    const editProjectObjectives = () => {
        setShowModal(true);
    }

    const handleCancel = () => {
        setShowModal(false);
    };

    const handleModalSubmit = async (values) => {
        try {
            setProjectObjectives(values);
            let objectives = [];
            values.forEach((objective) => objectives.push(objective.key));
            data.projectProfile.objectives = objectives;
            // if (otherObjectives !== undefined) data.projectProfile.otherObjectives = otherObjectives;
            let projectId = data.id;
            let project = data.projectProfile;
            project.objectives = objectives;
   
            const request = await service.editProject(
                project,
                projectId
            );

            if (request?.status == 200 || request?.status == 201) {
                msg = util.parseMessage(Messages.ADD_SUCCESS, "Project objectives");
                openNotification("Project Objectives", msg, Notify.SUCCESS);
             }
            setShowModal(false);
        } catch (error) {
            msg = util.parseMessage(Messages.GET_FAILURE);
            openNotification("Project Objectives", msg, Notify.ERROR);
            recordError(error);
        };
    };

    return (
        <div className=''>
            <Col xs={24}>
                <div className="public-portal-section">
                    <h2> Citizen Science - {data.name}</h2>
                </div>
            </Col>
            {/* {(data.status !== "Rejected" && data.status !== "Closed") && ( */}
                <Col xs={24}>
                    <h3 className="center-align">Project Status - <span style={{ color: data.statusColor }}>{data.status}</span> </h3>
                </Col>
            {/* )} */}
            <Card
                bordered={false}
                headStyle={{ border: 0, textAlign: "center" }}
            >
                <Row>
                    <Col xs={12}><h3 className="h3-text">Project Objectives</h3></Col>
                    {(data.status !== "Rejected" && data.status !== "Closed") && (
                    <Col xs={12}>
                        <Button className="right-align-button edit-button" type="primary" shape="round" onClick={() => editProjectObjectives()} >
                            Edit
                        </Button>
                    </Col>
                    )}
                </Row>
                <div className="space"></div>
                <List
                    itemLayout="vertical"
                    pagination={{
                        pageSize: 10,
                    }}
                    dataSource={projectObjectives}
                    renderItem={(objective) => (
                        <List.Item key={objective.id} >

                            <Row>
                                <Col xs={3} sm={2} md={1}>
                                    <Image width="20px" height="20px"
                                        src={require("../../../assets/bullet.png")}
                                    />
                                </Col>
                                <Col xs={20} md={20}>
                                {objective.value}
                                    {/* {objective.value !== "Other" && objective.value} */}
                                    {/* {objective.value === "Other" && <>
                                        {objective.value} : {data.projectProfile.otherObjectives}
                                    </>} */}
                                </Col>
                            </Row>


                        </List.Item>

                    )}
                />

            </Card>
            <Row>
                <Col xs={24}>
                    <EditObjectives
                        data={data}
                        visible={showModal}
                        onCancel={handleCancel}
                        onModalSubmit={handleModalSubmit}
                    />
                </Col>
            </Row>

        </div>
    )
}
